import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  enableProdMode,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LicenseManager } from 'ag-grid-enterprise';

import {
  AgGridLicence,
  setQzTrayLicense,
  AuthService,
  ConfigService,
  LoadingInterceptor,
  LanguageService,
  TmsLibModule,
  AuthModule,
  registerLocales,
} from 'tms-lib';
import { TmsWebGridService, TmsWebTranslationService } from 'tms-web-shared';
import { environment } from './environments/environment';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      TmsLibModule,
      AuthModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        // Register the ServiceWorker as soon as the app is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      const gridService = inject(TmsWebGridService);
      const translationService = inject(TmsWebTranslationService);
      const configService = inject(ConfigService);

      registerLocales();

      authService.homeRoute = 'Home';
      gridService.load();
      translationService.load();
      return configService.load();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: localStorage.getItem(LanguageService.LanguageKey) ?? LanguageService.DefaultLanguage,
    },
  ],
}).catch((err) => console.error(err));

LicenseManager.setLicenseKey(AgGridLicence);

setQzTrayLicense();
